import React from 'react';
import { Link } from 'react-router-dom';
import { useTheme } from '../../contexts/ThemeContext';
import { useAuth } from '../../contexts/AuthContext';
import SportSelector from '../SportSelector';
import './Header.css';

const Header: React.FC = () => {
  const { currentSport, theme } = useTheme();
  const { user, signOut } = useAuth();

  return (
    <header className="header">
      <div className="container">
        <div className="header-content">
          <div className="header-brand">
            <Link to="/" className="brand-link">
              <div className="logo-container">
                <img 
                  src={`/${currentSport.id === 'pickleball' ? 'mypickleballcoach.online.png' : 
                        currentSport.id === 'golf' ? 'mygolfgamecoach.online.png' :
                        currentSport.id === 'tennis' ? 'mytennisgamecoach.online.png' :
                        currentSport.id === 'hiking' ? 'myhikingcoach.online.png' :
                        currentSport.id === 'padel' ? 'padel-icon.svg' :
                        currentSport.id === 'badminton' ? 'badminton-icon.svg' :
                        currentSport.id === 'racquetball' ? 'racquetball-icon.svg' :
                        currentSport.id === 'squash' ? 'squash-icon.svg' : 'mysportscoach.online.png'}`}
                  alt={`${currentSport.name} Logo`} 
                  className="logo-image"
                />
                <div className="logo-text">
                  <h1 className="app-title">My Sports Coach</h1>
                  <p className="app-tagline">Your sport. Your AI Coach online</p>
                </div>
              </div>
            </Link>
            <p className="app-description">{currentSport.description}</p>
          </div>
          
          <div className="header-actions">
            <SportSelector variant="header" />
            {user ? (
              <div className="user-menu">
                <span className="user-name">Welcome, {user.name}!</span>
                <Link to="/profile" className="auth-button">
                  Profile
                </Link>
                <button onClick={signOut} className="auth-button signout">
                  Sign Out
                </button>
              </div>
            ) : (
              <div className="auth-links">
                <Link to="/signin" className="auth-button">Sign In</Link>
                <Link to="/signup" className="auth-button auth-button-outline">Create Account</Link>
              </div>
            )}
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
